import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "description" }
const _hoisted_2 = { class: "contentHolder" }
const _hoisted_3 = { class: "text" }

import TechnoFrame from "@/components/Common/TechnoFrame.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'TestDescription',

    data() {
        return {
        }
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "34eb10a5": (`url("/img/page/landing/main/bg/7.webp")`)
}))


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TechnoFrame, {
      offset: 5,
      "size-modifier": 0.3
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, [
          _createTextVNode("Что такое "),
          _createElementVNode("span", { class: "highlighted" }, "закрытый бета-тест"),
          _createTextVNode("?")
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, [
          _createElementVNode("span", { class: "highlighted" }, "ЗБТ"),
          _createTextVNode(" - это первоначальная версия игры, запущенная для ограниченного числа участников.")
        ], -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "Поскольку на этой стадии игра ещё содержит некоторые баги и недочёты, игровой процесс может быть не вполне стабильным. Игроки, участвующие в тестировании, могут обнаружить ошибки и сообщить о них администрации игры. Также участники тестирования могут выдвигать идеи и предложения, касающиеся улучшения любых аспектов игры: от расположения кнопок до ключевых игровых механик.", -1)),
        _createElementVNode("p", null, [
          _cache[1] || (_cache[1] = _createTextVNode("Чтобы поучаствовать в ")),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "highlighted" }, "ЗБТ", -1)),
          _cache[3] || (_cache[3] = _createTextVNode(", нужно приобрести пропуск. Сделать это можно на странице ")),
          _createVNode(_component_router_link, {
            to: "register",
            class: "highlighted"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("регистрации")
            ])),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode("."))
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, [
          _createElementVNode("span", { class: "highlighted" }, "Участники ЗБТ"),
          _createTextVNode(" - это Первопроходцы, которые вносят неоценимый вклад в развитие проекта.")
        ], -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, [
          _createTextVNode("Присоединяйся к эксклюзивному "),
          _createElementVNode("span", { class: "highlighted" }, "закрытому бета-тестированию"),
          _createTextVNode("!")
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("ul", null, [
          _createElementVNode("li", null, "Возможность первым протестировать новые игровые механики и функции"),
          _createElementVNode("li", null, "Отправляйся в путешествие по неизведанным мирам и разгадывай их тайны"),
          _createElementVNode("li", null, "Взаимодействуй с живыми игроками и обменивайся опытом"),
          _createElementVNode("li", null, "Близкое общение с разработчиками, всегда открытыми к диалогу и готовыми выслушать твоё мнение. Оно действительно важно!")
        ], -1))
      ])
    ])
  ]))
}
}

})